/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AttachmentTokenModel } from '../models/attachment-token-model';
import { BeginChunkedUploadCommand } from '../models/begin-chunked-upload-command';
import { BeginChunkedUploadResponse } from '../models/begin-chunked-upload-response';
import { CommitChunkedUploadResponse } from '../models/commit-chunked-upload-response';

@Injectable({
  providedIn: 'root',
})
export class AttachmentsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getBlobStorageToken
   */
  static readonly GetBlobStorageTokenPath = '/api/attachments/token';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBlobStorageToken$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBlobStorageToken$Plain$Response(params?: {
    fileName?: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<AttachmentTokenModel>> {

    const rb = new RequestBuilder(this.rootUrl, AttachmentsService.GetBlobStorageTokenPath, 'get');
    if (params) {
      rb.query('fileName', params.fileName, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AttachmentTokenModel>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getBlobStorageToken$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBlobStorageToken$Plain(params?: {
    fileName?: string;
    context?: HttpContext
  }
): Observable<AttachmentTokenModel> {

    return this.getBlobStorageToken$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<AttachmentTokenModel>) => r.body as AttachmentTokenModel)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBlobStorageToken()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBlobStorageToken$Response(params?: {
    fileName?: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<AttachmentTokenModel>> {

    const rb = new RequestBuilder(this.rootUrl, AttachmentsService.GetBlobStorageTokenPath, 'get');
    if (params) {
      rb.query('fileName', params.fileName, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AttachmentTokenModel>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getBlobStorageToken$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBlobStorageToken(params?: {
    fileName?: string;
    context?: HttpContext
  }
): Observable<AttachmentTokenModel> {

    return this.getBlobStorageToken$Response(params).pipe(
      map((r: StrictHttpResponse<AttachmentTokenModel>) => r.body as AttachmentTokenModel)
    );
  }

  /**
   * Path part for operation beginChunkedUpload
   */
  static readonly BeginChunkedUploadPath = '/api/attachments/upload/begin';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `beginChunkedUpload$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  beginChunkedUpload$Plain$Response(params?: {
    context?: HttpContext
    body?: BeginChunkedUploadCommand
  }
): Observable<StrictHttpResponse<BeginChunkedUploadResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AttachmentsService.BeginChunkedUploadPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BeginChunkedUploadResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `beginChunkedUpload$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  beginChunkedUpload$Plain(params?: {
    context?: HttpContext
    body?: BeginChunkedUploadCommand
  }
): Observable<BeginChunkedUploadResponse> {

    return this.beginChunkedUpload$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BeginChunkedUploadResponse>) => r.body as BeginChunkedUploadResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `beginChunkedUpload()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  beginChunkedUpload$Response(params?: {
    context?: HttpContext
    body?: BeginChunkedUploadCommand
  }
): Observable<StrictHttpResponse<BeginChunkedUploadResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AttachmentsService.BeginChunkedUploadPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BeginChunkedUploadResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `beginChunkedUpload$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  beginChunkedUpload(params?: {
    context?: HttpContext
    body?: BeginChunkedUploadCommand
  }
): Observable<BeginChunkedUploadResponse> {

    return this.beginChunkedUpload$Response(params).pipe(
      map((r: StrictHttpResponse<BeginChunkedUploadResponse>) => r.body as BeginChunkedUploadResponse)
    );
  }

  /**
   * Path part for operation uploadBlock
   */
  static readonly UploadBlockPath = '/api/attachments/upload/{uploadId}/block';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadBlock()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadBlock$Response(params: {
    uploadId: string;
    blockIndex?: number;
    context?: HttpContext
    body?: {
'block'?: Blob;
}
  }
): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AttachmentsService.UploadBlockPath, 'post');
    if (params) {
      rb.path('uploadId', params.uploadId, {});
      rb.query('blockIndex', params.blockIndex, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `uploadBlock$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadBlock(params: {
    uploadId: string;
    blockIndex?: number;
    context?: HttpContext
    body?: {
'block'?: Blob;
}
  }
): Observable<void> {

    return this.uploadBlock$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation commitChunkedUpload
   */
  static readonly CommitChunkedUploadPath = '/api/attachments/upload/{uploadId}/commit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commitChunkedUpload$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  commitChunkedUpload$Plain$Response(params: {
    uploadId: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<CommitChunkedUploadResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AttachmentsService.CommitChunkedUploadPath, 'post');
    if (params) {
      rb.path('uploadId', params.uploadId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CommitChunkedUploadResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `commitChunkedUpload$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commitChunkedUpload$Plain(params: {
    uploadId: string;
    context?: HttpContext
  }
): Observable<CommitChunkedUploadResponse> {

    return this.commitChunkedUpload$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CommitChunkedUploadResponse>) => r.body as CommitChunkedUploadResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commitChunkedUpload()` instead.
   *
   * This method doesn't expect any request body.
   */
  commitChunkedUpload$Response(params: {
    uploadId: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<CommitChunkedUploadResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AttachmentsService.CommitChunkedUploadPath, 'post');
    if (params) {
      rb.path('uploadId', params.uploadId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CommitChunkedUploadResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `commitChunkedUpload$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commitChunkedUpload(params: {
    uploadId: string;
    context?: HttpContext
  }
): Observable<CommitChunkedUploadResponse> {

    return this.commitChunkedUpload$Response(params).pipe(
      map((r: StrictHttpResponse<CommitChunkedUploadResponse>) => r.body as CommitChunkedUploadResponse)
    );
  }

}
